(function (Drupal, $) {
  Drupal.behaviors.motion_point = {
    attach: function attach(context) {
      // Add a class to indicate if user has Spanish mode turned on to change the toggle
      var host = window.location.host;
      var subdomain = host.split('.')[0];
      if(subdomain.includes('es')) {
        $('.language-toggle .slider').addClass('translated');
      }
    }
  }
})(Drupal, jQuery);
